import { UserFilesModel } from "./../../pages/admin/definitions/users/models/user-flles.model";
import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  Inject,
  ViewChild,
  ElementRef,
  OnDestroy,
  AfterViewInit,
  HostListener,
  NgZone,
} from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { EventService } from "../../core/services/event.service";

//Logout
import { environment } from "../../../environments/environment";
import { AuthService } from "../../core/services/auth.service";
import { Router } from "@angular/router";

// Language
import { CookieService } from "ngx-cookie-service";
import { LanguageService } from "../../core/services/language.service";
import { TranslateService } from "@ngx-translate/core";
import { NotificationService } from "src/app/core/services/notification.service";
import {
  ChatMessage,
  NotifcationModel,
} from "src/app/core/models/notification.models";
import { MenuService } from "src/app/core/services/menu.service";
import { ChatService } from "src/app/pages/chat/services/chat.service";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { BehaviorSubject, Subscription } from "rxjs";
import { ExchangeService } from "src/app/core/services/exchange.service";
import { SimulatorsModalComponent } from "src/app/shared/modals/simulators/simulators-modal.component";
import { ImpersonationModalComponent } from "./impersonation-modal/impersonation-modal.component";
import { TopBarService } from "./services/top-bar.services";
import { AgencyModel, CountryAgencyModel } from "../models/country-agency-mode";
import { ContactsService } from "src/app/pages/contacts/services/contacts.service";
import Swal from "sweetalert2";
import { DealsService } from "src/app/pages/deals/services/deals.service";
import { PermissionsService } from "src/app/core/services/permissions.service";
import { ToastrService } from "ngx-toastr";
import { AiWalletStateService } from "src/app/core/services/ai-wallet-state.service";

@Component({
  selector: "app-topbar",
  templateUrl: "./topbar.component.html",
  styleUrls: ["./topbar.component.scss"],
})
export class TopbarComponent implements OnInit, AfterViewInit, OnDestroy {
  private readonly layoutModeStorageKey = "layout-mode";
  element: any;
  mode: string | undefined;
  @Output() mobileMenuButtonClicked = new EventEmitter();
  @ViewChild("contenttop", { static: true }) contenttop!: ElementRef;
  @ViewChild("contentExchange", { static: true }) contentExchange!: ElementRef;
  flagvalue: any;
  valueset: any;
  countryName: any;
  cookieValue: any;
  listLang: any = [];
  currentUser!: any;
  pathProfileImage = `${environment.apiUrl}/${environment.dirProfileImage}/`;
  notifications: NotifcationModel[] = [];
  countNotification = 0;
  countNotificationLeads = 0;
  countNotificationAlers = 0;
  countNotificationMessages = 0;
  notificationsLeads: NotifcationModel[] = [];
  notificationsAlers: NotifcationModel[] = [];
  notificationsMessages: ChatMessage[] = [];
  // Chaves cuja mensagem é o próprio título (referenciações e processos);
  // qualquer outra cai nos títulos genéricos de atribuição de lead.
  readonly referralNotificationKeys = new Set<string>([
    "t-deals-referral-notification-assigned",
    "t-deals-referral-notification-accepted",
    "t-deals-referral-notification-rejected",
    "t-deals-referral-notification-canceled",
    "t-deals-referral-notification-won",
    "t-deals-referral-notification-lost",
    "t-deals-process-returned-to-sales-notification",
  ]);
  langValue: any;
  page1: number = 1;
  page2: number = 1;
  page3: number = 1;
  portalListErrors = false;
  portalIdErrors!: number;
  portalNameErrors!: string;
  portalExportError!: {
    id: number;
    name: string;
    status: boolean;
    isExported: boolean;
  };
  portalErrorsSubscription!: Subscription;
  /**
   * Os cinco listeners de chat abaixo. O ChatService e um singleton sobre o socket
   * partilhado; sem isto cada topbar destruida (logout + login no mesmo separador)
   * deixava os seus listeners vivos, e cada mensagem passava a disparar um
   * GET /notifications/messages por topbar antiga.
   */
  private chatSubscriptions: Subscription = new Subscription();
  portalExportSubscription!: Subscription;
  nabTabActive = 1;
  private currentNavTabSubject!: BehaviorSubject<number>;
  totalExport!: { totalexp: number; totalNotexp: number };
  isPortalAlert = false;
  modalRef!: NgbModalRef;
  exchanges!: { currencyCode: any; exchangeDate: any; exchangeRate: any }[];
  countries: CountryAgencyModel[] = [];
  agencies: AgencyModel[] = [];
  // countrySelected: CountryAgencyModel | undefined
  agenciesSelected: AgencyModel[] = [];
  selectedCountryId!: number | null;
  selectedAgenciesId!: number[];
  // previousCountrySelected: CountryAgencyModel | undefined
  @ViewChild("dropdownCountryRef") dropdownRef!: ElementRef;
  propertyContactsNotifications: { contacts: any[]; property: any } | undefined;
  selectedContacts: { contacts: any[]; property: any } | undefined;
  notificationProgress: number = 0;
  notificationInterval: any;
  contactSelected: any;
  pathImage = `${environment.apiUrl}${environment.dirPropertiesImages}/`;
  pathLogoImage = `${environment.apiUrl}/${environment.dirLogoImage}/`;

  latestNotification: any[] = [];
  markingAllNotificationsAsRead = false;

  constructor(
    @Inject(DOCUMENT) private document: any,
    private eventService: EventService,
    public languageService: LanguageService,
    public _cookiesService: CookieService,
    public translate: TranslateService,
    private authService: AuthService,
    private router: Router,
    private notificationService: NotificationService,
    private langService: LanguageService,
    private menuService: MenuService,
    private chatService: ChatService,
    private modalService: NgbModal,
    private exchangeService: ExchangeService,
    public topBarService: TopBarService,
    private contactsService: ContactsService,
    private dealsService: DealsService,
    public permissionsService: PermissionsService,
    private toastr: ToastrService,
    private zone: NgZone,
    private aiWalletState: AiWalletStateService
  ) { }

  // ── AI Credits indicator ────────────────────────────────────────────────
  aiIndicatorEnabled = false;
  aiHasWallet = false;
  aiAvailableBalance: number | null = null;
  aiBalancePulsing = false;
  aiBurstAmount: number | null = null;
  canViewAiIntegrations = false;
  private aiBalanceSub?: Subscription;
  private aiHasWalletSub?: Subscription;
  private aiPulseSub?: Subscription;
  private aiBurstTimeout?: any;

  goToAiCredits(): void {
    if (!this.canViewAiIntegrations) return;
    this.router.navigate(["/ai-integrations"]);
  }

  /** Simuladores de IMT e crédito, sem sair da página onde se está. */
  openSimulators(): void {
    this.modalService.open(SimulatorsModalComponent, {
      size: "xl",
      centered: true,
      scrollable: true,
    });
  }

  private initAiWalletWatcher(): void {
    this.canViewAiIntegrations =
      this.permissionsService.hasPermission("VIEW_AI_INTEGRATIONS");

    if (!this.canViewAiIntegrations) {
      this.aiWalletState.reset();
      this.aiIndicatorEnabled = false;
      this.aiHasWallet = false;
      this.aiAvailableBalance = null;
      return;
    }

    // Support users (Imodigi staff) and users without an associated entity
    // do not have an AI wallet — keep the indicator hidden.
    const u = this.currentUser;
    if (!u || !u.entity) {
      this.aiWalletState.reset();
      this.aiIndicatorEnabled = false;
      this.aiHasWallet = false;
      return;
    }
    this.aiIndicatorEnabled = true;
    this.aiWalletState.refresh();
    this.aiHasWalletSub = this.aiWalletState.hasWallet$.subscribe((has) => {
      this.aiHasWallet = has;
    });
    this.aiBalanceSub = this.aiWalletState.balance$.subscribe((b) => {
      this.aiAvailableBalance = b ?? 0;
    });
    this.aiPulseSub = this.aiWalletState.pulse$.subscribe(({ credits }) => {
      this.zone.run(() => {
        this.aiBalancePulsing = true;
        this.aiBurstAmount = credits;
        clearTimeout(this.aiBurstTimeout);
        this.aiBurstTimeout = setTimeout(() => {
          this.aiBalancePulsing = false;
          this.aiBurstAmount = null;
        }, 1500);
      });
    });
  }

  ngOnInit(): void {
    this.currentUser = this.authService.currentUserValue;
    this.startProgress();
    this.eventService.subscribe(
      "find-contacts-by-property",
      (data: { propertyId: any }) => {
        if (data.propertyId && !this.propertyContactsNotifications?.property) {
          this.contactsService
            .findContactsWithPreferencesByProperty(data.propertyId)
            .subscribe({
              next: (response) => {
                if (
                  response?.contacts &&
                  response?.contacts?.length > 0 &&
                  response?.property
                ) {
                  setTimeout(() => {
                    if (!this.propertyContactsNotifications?.property) {
                      this.propertyContactsNotifications = {
                        contacts: response?.contacts,
                        property: response?.property,
                      };
                      this.startProgress();
                    }
                  }, 3000);
                }
              },
            });
        }
      }
    );
    this.loadJS();
    this.totalExport = { totalexp: 0, totalNotexp: 0 };
    this.currentNavTabSubject = new BehaviorSubject<number>(1);
    this.languageService.getLanguages().subscribe((data) => {
      this.listLang = data;
      this.initFlag();
    });

    this.langValue = this.langService.getCurrentLang();
    this.langService.currentLangSubject.subscribe((lang) => {
      if (this.langValue !== lang) {
        this.langValue = lang;
        this.loadData();
      }
    });

    this.element = document.documentElement;
    this.applyPersistedMode();

    this.loadData();

    this.initAiWalletWatcher();

    this.notificationService.receiveNotifyLeads().subscribe((data) => {
      const notificationData = this.notificationsLeads.find(
        (n) => n.id === data.id
      );
      if (!notificationData) {
        this.notificationsLeads.unshift(data);
      }

      this.setCountNotifications();
    });

    this.notificationService.receiveNotifyProperties().subscribe(() => {
      this.notificationsLeads = [];
      this.notificationsAlers = [];
      this.notificationsMessages = [];
      this.loadData();
      this.getLatestNotification();
    });

    this.eventService.subscribe(
      "push-notifications-calendar-events",
      (data) => {
        data.forEach((d: any) => {
          const notificationData = this.notificationsAlers.find(
            (n) => n.eventId === d.eventId && n.type === "CALENDAR_EVENT"
          );
          if (!notificationData) {
            this.notificationsAlers.push(d);
          } else {
            this.notificationsAlers = this.notificationsAlers.filter(
              (n) => n.eventId !== d.eventId
            );
            this.notificationsAlers.push(d);
          }
          this.setCountNotifications();
        });
      }
    );

    this.eventService.subscribe(
      "push-notifications-mediation-agreement",
      (data) => {
        data.forEach((d: any) => {
          // Dedupe pelo id da notificação: um aviso de prazo e um "CMI
          // assinado" do mesmo imóvel partilham o eventId e substituíam-se.
          const notificationData: any = this.notifications.find(
            (n) => n.id === d.id && n.type === "MEDIATION_AGREEMENT"
          );
          if (!notificationData) {
            this.notificationsAlers.push(d);
          } else {
            this.notificationsAlers = this.notificationsAlers.filter(
              (n) => n.id !== d.id
            );
            this.notificationsAlers.push(d);
          }
          this.setCountNotifications();
        });
      }
    );

    this.eventService.subscribe(
      "push-notifications-lead-assignment",
      (data) => {
        this.notificationsLeads = this.notificationsLeads.filter(
          (n) => n.type !== "LEAD_ASSIGNMENT"
        );
        if (data?.length > 0) {
          data.forEach((d: any) => {
            const notificationData: any = this.notificationsLeads.find(
              (n) => n.eventId === d.eventId && n.type === "LEAD_ASSIGNMENT"
            );
            if (!notificationData) {
              this.notificationsLeads.push(d);
            } else {
              // this.notificationsLeads = this.notificationsLeads.filter(n => n.eventId !== d?.eventId);
              // this.notificationsLeads.push(d);
            }
          });
        }
        if (this.notificationsLeads.length > 0) {
          this.notificationsLeads = this.notificationsLeads.sort(
            (a: any, b: any) => {
              return (
                new Date(b.createdAt).getTime() -
                new Date(a.createdAt).getTime()
              );
            }
          );
        }
        this.setCountNotifications();
      }
    );

    this.eventService.subscribe("update-notifications", () => {
      this.notificationsLeads = [];
      this.notificationsAlers = [];
      this.notificationsMessages = [];
      this.loadData();
    });

    // O chat (página ou balão flutuante, em qualquer rota) acabou de ler ou receber mensagens.
    this.eventService.subscribe("update-notifications-messages", () => {
      this.notificationsMessages = [];
      this.notificationService.getMessages().subscribe({
        next: (data) => {
          this.notificationsMessages = data;
          this.updateNotificationsMessagesStatus(data);
          this.setCountNotifications();
        },
        error: (err) => { },
      });
    });

    this.eventService.subscribe("open-exchange-rates", () => {
      this.exchangeModal();
    });

    this.chatSubscriptions.add(this.chatService.receiveMessage().subscribe({
      next: (data: any) => {
        // console.log('chat')
        if (this.router.url !== "/chat") {
          this.notificationsMessages = [];
          this.notificationService.getMessages().subscribe({
            next: (data) => {
              this.notificationsMessages = data;
              this.updateNotificationsMessagesStatus(data);
              this.setCountNotifications();
            },
            error: (err) => { },
          });
        }
      },
      error: (err) => { },
    }));

    this.chatSubscriptions.add(this.chatService.receiveMessageFile().subscribe({
      next: (data: any) => {
        if (this.router.url !== "/chat") {
          this.notificationsMessages = [];
          this.notificationService.getMessages().subscribe({
            next: (data) => {
              this.notificationsMessages = data;
              this.updateNotificationsMessagesStatus(data);
              this.setCountNotifications();
            },
            error: (err) => { },
          });
        }
      },
      error: (err) => { },
    }));

    this.chatSubscriptions.add(this.chatService.receiveMessageDelete().subscribe({
      next: (data: any) => {
        if (this.router.url !== "/chat") {
          this.notificationsMessages = [];
          this.notificationService.getMessages().subscribe({
            next: (data) => {
              this.notificationsMessages = data;
              this.updateNotificationsMessagesStatus(data);
              this.setCountNotifications();
            },
            error: (err) => { },
          });
        }
      },
      error: (err) => { },
    }));

    this.chatSubscriptions.add(this.chatService.receiveMessageDeleteFiles().subscribe({
      next: (data: any) => {
        if (this.router.url !== "/chat") {
          this.notificationsMessages = [];
          this.notificationService.getMessages().subscribe({
            next: (data) => {
              this.notificationsMessages = data;
              this.updateNotificationsMessagesStatus(data);
              this.setCountNotifications();
            },
            error: (err) => { },
          });
        }
      },
      error: (err) => { },
    }));

    this.chatSubscriptions.add(this.chatService.receiveDeleteChat().subscribe({
      next: (data: any) => {
        if (this.router.url !== "/chat") {
          this.notificationsMessages = [];
          this.notificationService.getMessages().subscribe({
            next: (data) => {
              this.notificationsMessages = data;
              this.updateNotificationsMessagesStatus(data);
              this.setCountNotifications();
            },
            error: (err) => { },
          });
        }
      },
      error: (err) => { },
    }));
    if (!this.portalErrorsSubscription)
      this.portalErrorsSubscription = this.eventService.subscribe(
        "init-modal-portal-errors",
        (data) => {
          // setTimeout(() => {
          // this.portalIdErrors = data.id
          // this.portalNameErrors = data.name
          // this.portalListErrors = true
          this.nabTabActive = 1;
          this.portalExportError = {
            id: data.id,
            name: data.name,
            status: true,
            isExported: true,
          };
          this.initModalPortalErrors();
          // });
        }
      );

    if (!this.portalExportSubscription)
      this.portalErrorsSubscription = this.eventService.subscribe(
        "total-properties-export",
        (data) => {
          if (this.portalExportError?.status) this.totalExport = data;
        }
      );

    this.topBarService.getCountriescontainsProperties().subscribe({
      next: (value) => {
        this.countries = value;
        const usersData = this.topBarService.getUserDataPref();
        if (usersData?.length > 0) {
          const data = usersData.find(
            (a) =>
              a.user.id === this.currentUser.id &&
              a.entity === this.currentUser.entity
          );
          if (data) {
            const country = this.countries.find((a) => a.id === data.id);
            if (
              country?.agencies &&
              country?.agencies?.length > 0 &&
              data?.agencies &&
              data?.agencies?.length > 0
            ) {
              this.agencies = country.agencies;
              this.topBarService.countrySelected = data;
              this.selectedCountryId = this.topBarService.countrySelected.id;
              if (this.topBarService.countrySelected.agencies)
                this.selectedAgenciesId =
                  this.topBarService.countrySelected.agencies.map(
                    (ag) => ag.id
                  );
            }
          }
        }
        this.topBarService.previousCountrySelected =
          this.topBarService.deepClone(this.topBarService.countrySelected);
      },
      error: (err) => { },
    });

    this.getLatestNotification();
  }

  getLatestNotification() {
    const today = new Date().toISOString().split("T")[0];

    this.topBarService.getLatest().subscribe({
      next: (data: any) => {
        const userId = data[0]?.userId;
        const storageKey = `lastNotificationShownDate__${userId}`;
        const lastShowDate = localStorage.getItem(storageKey);

        // console.log(data)

        if (lastShowDate === today) {
          return;
        }

        this.latestNotification = data;
        this.latestNotification = data.sort(
          (a: any, b: any) =>
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );

        // const unreadCount = this.latestNotification.filter((n: any) => !n.read).length || this.latestNotification.length

        this.latestNotification.forEach((notification, index) => {
          let title = "";
          let translatedTitle = "";
          let translatedMessage = "";

          const type = notification.notificationType?.description;
          let message = notification.messsage;
          let reference;

          let icon = '<i class="ri-mail-line"></i>';

          switch (type) {
            case "CALENDAR_EVENT":
              title = "t-calendar-event";
              icon = '<i class="ri-calendar-line"></i>';
              break;

            case "PROPOSALS":
              // title = 't-new-proposal-received'
              message = notification?.messsage

              if (message.includes('declined')) {
                icon = '<i class="ri-hand-coin-line icon-red"></i>'

              } else if (message.includes('counteroffer')) {

                icon = '<i class="ri-hand-coin-line icon-warning"></i>'
              } else {
                icon = '<i class="ri-hand-coin-line icon-green"></i>'

              }
              translatedMessage = this.translate.instant(message, {
                reference: notification.property?.reference ?? notification.externalProposal?.reference
              })




              title = "";
              break;

            // translatedMessage = this.translate.instant(message, {
            //   reference: notification.property?.reference ?? ''
            // })

            case "LEAD_ASSIGNMENT":
              title = this.getLeadAssignmentTitleKey(notification.messsage);
              message = notification?.lead?.email;
              icon = '<i class="ri-alert-line icon-blue" ></i>';
              break;

            case "MEDIATION_AGREEMENT":
              // title = notification.messsage
              // message = notification?.lead?.email
              icon = '<i class="ri-alert-line icon-warning" ></i>';
              translatedMessage = this.translate.instant(message, {
                reference: notification.property?.reference ?? ''
              })
              break

            case "LEADS":
              title = notification.messsage = "Lead";
              message = notification?.lead?.email;
              icon = '<i class="ri-mail-line icon-blue" ></i>';
              break;

            case "PORTAL_ALERTS":
              icon = '<i class="ri-alert-line icon-warning" ></i>';
              message = notification?.messsage;
              translatedMessage = this.translate.instant(message, {
                portal: notification.portal?.name ?? ''
              })
              break;

            case "PROPERTIES":
              message = notification?.messsage;
              const isMinimumCommissionValidation =
                message?.includes("minimum-commission-validate");
              const isMinimumCommissionApproval =
                message?.includes("minimum-commission-approved");

              if (message.includes('property-validate') || isMinimumCommissionValidation) {
                icon = '<i class="ri-home-3-line icon-warning"></i>'

              } else if (message.includes('property-approved') || isMinimumCommissionApproval) {

                icon = '<i class="ri-checkbox-circle-line icon-green"></i>'
              } else {
                icon = '<i class="ri-close-circle-line icon-red"></i>'
              }
              translatedMessage = this.translate.instant(message, {
                reference: notification?.property?.reference,
                agent: notification?.createddBy, approver: notification?.createddBy
              });

              break;


          }

          const safeTranslate = (text: any) => {
            if (typeof text === "string" && text.startsWith("t-")) {
              return this.translate.instant(text);
            }
            return text ?? "";
          };

          translatedTitle = translatedTitle || safeTranslate(title);
          translatedMessage = translatedMessage || safeTranslate(message);

          // const isLast = index === this.latestNotification.length - 1
          // let extraInfo = ''
          // if(isLast && unreadCount > 0){
          //   extraInfo = `<span class="unread-count">(${unreadCount} unread notifications)</span>`
          // }

          const toast = this.toastr.show(
            `${icon} `,
            ` ${translatedTitle} 
            ${translatedMessage}`,
            {
              ...this.toastOptions(),
              toastClass: "ngx-toastr custom-toast",
            }
          );

          toast.onTap.subscribe(() => {
            const formattedNotification = {
              id: notification.id,
              read: false,
              type: notification?.notificationType?.description,
              eventId: notification?.lead?.id ?? null,
              dealId: notification?.lead?.deal?.id ?? null,
              dealListingId: notification?.lead?.dealsListing?.id ?? null,
              dealProcessId: notification?.lead?.dealProcess?.id ?? null,
              proposalId: notification?.externalProposal?.id ?? null,
              propertyId: notification?.property?.id ?? null,
              externalProposalId: notification?.externalProposalId ?? null,
              portalId: notification?.portalAlerts?.id ?? null,
              portalName: notification?.portals?.name ?? null,
              message: notification?.messsage,
            };

            if (
              notification.notificationType.description === "CALENDAR_EVENT"
            ) {
              formattedNotification.eventId = notification?.calendarEvent?.id;
            }

            this.updateNotificationToRead(formattedNotification);
          });
        });

        localStorage.setItem(storageKey, today);
      },
    });
  }

  // Os toasts fecham sozinhos ao fim de 8s (a barra de progresso mostra a
  // contagem). Com o rato em cima o tempo pára; ao sair têm mais 2s. O
  // ToastrModule global usa timeOut 0, por isso os tempos ficam definidos aqui.
  toastOptions() {
    return {
      tapToDismiss: true, // precisa ser true para permitir o clique
      disableTimeOut: false,
      timeOut: 10000,
      extendedTimeOut: 2000,
      closeButton: true,
      progressBar: true,
      enableHtml: true,
    };
  }

  ngAfterViewInit(): void {
    this.topBarService.triggerSyncIfNeeded(this.currentUser);
    if (this.currentUser?.role?.name === "MASTER")
      this.dropdownRef.nativeElement.addEventListener(
        "hidden.bs.dropdown",
        () => {
          if (
            !this.topBarService.countrySelected ||
            (this.topBarService.countrySelected?.agencies &&
              this.topBarService.countrySelected?.agencies?.length == 0)
          ) {
            this.onResetCountry();
          } else {
            // window.location.reload();
          }

          if (this.topBarService.checkChanges()) {
            this.topBarService.previousCountrySelected =
              this.topBarService.deepClone(this.topBarService.countrySelected);
            this.topBarService.update(this.currentUser);
          }
        }
      );
  }

  startProgress() {
    if (this.notificationInterval) {
      clearInterval(this.notificationInterval);
    }

    this.notificationProgress = 0;
    const duration = 30000; // 30 segundos para completar 100%
    const stepTime = 50; // Atualiza a cada 50ms
    const increment = 100 / (duration / stepTime);

    this.notificationInterval = setInterval(() => {
      this.notificationProgress += increment;

      if (this.notificationProgress >= 100) {
        this.notificationProgress = 100;

        clearInterval(this.notificationInterval);

        this.propertyContactsNotifications = undefined;
        setTimeout(() => {
          this.notificationProgress = 0;
        }, 300);
      }
    }, stepTime);
  }

  loadData() {
    this.notificationService.getAll().subscribe({
      next: (data) => {
        // console.log('data loadData', data)

        data?.leads
          ?.sort(
            (a: any, b: any) =>
              new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
          )
          .forEach((d: any) => {
            const notificationData = this.notificationsLeads.find(
              (n) => n.id === d.id
            );
            if (!notificationData) {
              this.notificationsLeads.push(d);
            }
          });

        data?.calendarEvents?.forEach((d: any) => {
          const notificationData = this.notificationsAlers.find(
            (n) => n.id === d.id
          );

          if (!notificationData) {
            this.notificationsAlers.push(d);
          }
        });

        data?.mediationAgreements?.forEach((d: any) => {
          const notificationData = this.notificationsAlers.find(
            (n) => n.id === d.id
          );
          if (!notificationData) {
            this.notificationsAlers.push(d);
          }
        });

        data?.portalAlerts?.forEach((d: any) => {
          const notificationData = this.notificationsAlers.find(
            (n) => n.id === d.id
          );
          if (!notificationData) {
            this.notificationsAlers.push(d);
          }
        });

        data?.proposals?.forEach((d: any) => {
          const notificationData = this.notificationsAlers.some(
            (n) => n.id === d.id && n.message === d.message
          );

          if (!notificationData) {
            this.notificationsAlers.push(d);
          }
        });

        data?.properties?.forEach((d: any) => {
          const notificationData = this.notificationsAlers.some(
            (n) => n.id === d.id && n.message === d.message
          );

          if (!notificationData) {
            this.notificationsAlers.push(d);
          }
        });

        if (data?.messages) {
          this.notificationsMessages = data.messages;
          this.updateNotificationsMessagesStatus(data.messages);
        }

        this.setCountNotifications();
      },
      error: (err) => { },
    });
  }

  private navigateToLeadNotification(notification: any): void {
    if (this.router.url !== "/leads") {
      this.menuService.setData({
        menu: "leads",
        id: notification.eventId,
      });
      this.router.navigate(["leads"]);
      return;
    }

    this.eventService.broadcast("menu-leads", {
      id: notification.eventId,
    });
  }

  private navigateToReferralDealNotification(notification: any): boolean {
    const dealProcessId = Number(notification?.dealProcessId ?? 0);
    const dealListingId = Number(notification?.dealListingId ?? 0);
    const dealId = Number(notification?.dealId ?? 0);

    let targetType: "sale" | "listing" | "process" | null = null;
    let targetDealId: number | null = null;

    if (Number.isFinite(dealProcessId) && dealProcessId > 0) {
      targetType = "process";
      targetDealId = dealProcessId;
    } else if (Number.isFinite(dealListingId) && dealListingId > 0) {
      targetType = "listing";
      targetDealId = dealListingId;
    } else if (Number.isFinite(dealId) && dealId > 0) {
      targetType = "sale";
      targetDealId = dealId;
    }

    if (!targetType || !targetDealId) {
      return false;
    }

    const payload = {
      menu: "deal-referral",
      dealType: targetType,
      dealId: targetDealId,
    };

    // Já num dos quadros (funil ou lista antiga): ambos ouvem o broadcast.
    if (this.router.url !== "/deals" && this.router.url !== "/deals/board") {
      this.menuService.openDealsBoard(payload);
      return true;
    }

    this.eventService.broadcast("menu-deals-referral", payload);
    return true;
  }

  private hasRelatedDealNotification(notification: any): boolean {
    const dealProcessId = Number(notification?.dealProcessId ?? 0);
    const dealListingId = Number(notification?.dealListingId ?? 0);
    const dealId = Number(notification?.dealId ?? 0);
    return (
      (Number.isFinite(dealProcessId) && dealProcessId > 0) ||
      (Number.isFinite(dealListingId) && dealListingId > 0) ||
      (Number.isFinite(dealId) && dealId > 0)
    );
  }

  private buildNotificationWithDealIdsFallback(notification: any, data: any): any {
    const leadsList = Array.isArray(data?.leads) ? data.leads : [];
    const match = leadsList.find(
      (item: any) => Number(item?.id) === Number(notification?.id),
    );

    if (!match) {
      return notification;
    }

    return {
      ...notification,
      eventId: notification?.eventId ?? match?.eventId ?? null,
      dealId: notification?.dealId ?? match?.dealId ?? null,
      dealListingId: notification?.dealListingId ?? match?.dealListingId ?? null,
      dealProcessId: notification?.dealProcessId ?? match?.dealProcessId ?? null,
    };
  }

  private openLeadAssignmentNotification(notification: any): void {
    if (
      this.hasRelatedDealNotification(notification) &&
      this.navigateToReferralDealNotification(notification)
    ) {
      return;
    }

    if (!notification?.id) {
      this.navigateToLeadNotification(notification);
      return;
    }

    this.notificationService.getAll().subscribe({
      next: (data) => {
        const enrichedNotification = this.buildNotificationWithDealIdsFallback(
          notification,
          data,
        );

        if (
          this.hasRelatedDealNotification(enrichedNotification) &&
          this.navigateToReferralDealNotification(enrichedNotification)
        ) {
          return;
        }

        this.navigateToLeadNotification(enrichedNotification);
      },
      error: () => {
        this.navigateToLeadNotification(notification);
      },
    });
  }

  hasUnreadNotificationsToMarkAll(): boolean {
    return (
      this.notificationsLeads.some((notification) => !notification?.read) ||
      this.notificationsAlers.some((notification) => !notification?.read)
    );
  }

  markAllNotificationsAsRead() {
    if (this.markingAllNotificationsAsRead) {
      return;
    }

    const hasUnreadNotifications = this.hasUnreadNotificationsToMarkAll();

    if (!hasUnreadNotifications) {
      return;
    }

    Swal.fire({
      title: this.translate.instant("t-leads-m.t-are-you-sure"),
      text: `${this.translate.instant("t-mark-all-as-read")}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#34c38f",
      cancelButtonColor: "#f46a6a",
      confirmButtonText: this.translate.instant("t-delete-confirm"),
      cancelButtonText: this.translate.instant("t-cancel"),
    }).then((result) => {
      if (!result.isConfirmed) {
        return;
      }

      this.markingAllNotificationsAsRead = true;
      this.notificationService.updateAllToRead().subscribe({
        next: () => {
          this.notificationsLeads = this.notificationsLeads.map(
            (notification) => ({
              ...notification,
              read: true,
            }),
          );
          this.notificationsAlers = this.notificationsAlers.map(
            (notification) => ({
              ...notification,
              read: true,
            }),
          );
          this.setCountNotifications();
          this.markingAllNotificationsAsRead = false;
        },
        error: (err) => {
          console.error(err);
          this.markingAllNotificationsAsRead = false;
        },
      });
    });
  }

  updateNotificationToRead(notification: any) {
    if (!notification.read) {
      this.notificationService.updateToRead(notification.id).subscribe({
        next: () => {
          const notif =
            this.notificationsLeads.find((n) => n.id === notification.id) ||
            this.notificationsAlers.find((n) => n.id === notification.id);

          if (notif) notif.read = true;

          switch (notification.type) {
            case "LEADS":
              this.navigateToLeadNotification(notification);
              break;

            case "LEAD_ASSIGNMENT":
              this.openLeadAssignmentNotification(notification);
              break;

            case "CALENDAR_EVENT":
              if (this.router.url !== "/calendar") {
                this.menuService.setData({
                  menu: "calendar",
                  id: notification.eventId,
                });
                this.router.navigate(["calendar"]);
              } else {
                this.eventService.broadcast("menu-calendar", {
                  id: notification.eventId,
                });
              }
              break;

            case "PORTAL_ALERTS":
              setTimeout(() => {
                this.isPortalAlert = true;
                this.portalExportError = {
                  id: notification.portalId,
                  name: notification.portalName,
                  status: true,
                  isExported: false,
                };
                this.initModalPortalErrors();
              });
              break;

            case "PROPOSALS":
              if (notification.proposalId) {
                if (this.router.url !== "/properties") {
                  this.menuService.setData({
                    menu: "proposals",
                    id: notification.proposalId,
                    propertyId: notification.propertyId,
                  });
                  this.router.navigate(["properties"]);
                } else {
                  this.eventService.broadcast("menu-proposals", {
                    id: notification.proposalId,
                    propertyId: notification.propertyId,
                  });
                }
              } else if (notification.externalProposalId) {
                if (this.router.url !== "/proposals") {
                  this.menuService.setData({
                    menu: "external-proposal",
                    id: notification.externalProposalId,
                  });
                  this.router.navigate(["proposals"]);
                } else {
                  this.eventService.broadcast("menu-external-proposal", {
                    id: notification.externalProposalId,
                  });
                }
              }
              break;

            case "PROPERTIES":
              if (notification.propertyId) {
                if (this.router.url !== "/properties") {
                  this.menuService.setData({
                    menu: "details",
                    id: notification.propertyId,
                    propertyId: notification.propertyId,
                  });
                  this.router.navigate(["properties"]);
                } else {
                  this.eventService.broadcast("menu-details", {
                    id: notification.propertyId,
                    propertyId: notification.propertyId,
                  });
                }
              }
              break;

            case "MEDIATION_AGREEMENT":
              this.navigateToMediationAgreementNotification(notification);
              break;
          }

          this.setCountNotifications();
        },
        error: (err: any) => console.error(err),
      });
    } else {
      switch (notification.type) {
        case "LEADS":
          this.navigateToLeadNotification(notification);
          break;

        case "LEAD_ASSIGNMENT":
          this.openLeadAssignmentNotification(notification);
          break;

        case "CALENDAR_EVENT":
          if (this.router.url !== "/calendar") {
            this.menuService.setData({
              menu: "calendar",
              id: notification.eventId,
            });
            this.router.navigate(["calendar"]);
          } else {
            this.eventService.broadcast("menu-calendar", {
              id: notification.eventId,
            });
          }
          break;

        case "PORTAL_ALERTS":
          setTimeout(() => {
            this.isPortalAlert = true;
            this.portalExportError = {
              id: notification.portalId,
              name: notification.portalName,
              status: true,
              isExported: false,
            };
            this.initModalPortalErrors();
          });
          break;

        case "PROPOSALS":
          if (notification.proposalId) {
            if (this.router.url !== "/properties") {
              this.menuService.setData({
                menu: "proposals",
                id: notification.proposalId,
                propertyId: notification.propertyId,
              });

              this.router.navigate(["properties"]);
            } else {
              this.eventService.broadcast("menu-proposals", {
                id: notification.proposalId,
                propertyId: notification.propertyId,
              });
            }
          } else if (notification.externalProposalId) {
            if (this.router.url !== "/proposals") {
              this.menuService.setData({
                menu: "external-proposal",
                id: notification.externalProposalId,
              });

              this.router.navigate(["proposals"]);
            } else {
              this.eventService.broadcast("menu-external-proposal", {
                id: notification.externalProposalId,
              });
            }
          }
          break;

        case "PROPERTIES":
          if (notification.propertyId) {
            if (this.router.url !== "/properties") {
              this.menuService.setData({
                menu: "details",
                id: notification.propertyId,
                propertyId: notification.propertyId,
              });

              this.router.navigate(["properties"]);
            } else {
              this.eventService.broadcast("menu-details", {
                id: notification.propertyId,
                propertyId: notification.propertyId,
              });
            }
          }
          break;

        case "MEDIATION_AGREEMENT":
          this.navigateToMediationAgreementNotification(notification);
          break;
      }
    }
  }

  /**
   * Notificações de mediação: o aviso de prazo do mandato abre a ficha do
   * imóvel; o "CMI assinado" traz o negócio de angariação e abre-se a página
   * dele já no separador do contrato (`?action=mediationcontract`). Antes as
   * duas ramificações (lida / por ler) divergiam e navegavam para a lista de
   * imóveis com id indefinido.
   */
  private navigateToMediationAgreementNotification(notification: any): void {
    const dealListingId = Number(notification?.dealListingId ?? 0);
    if (Number.isFinite(dealListingId) && dealListingId > 0) {
      this.router.navigate(["/deals/listing", dealListingId], {
        queryParams: { action: "mediationcontract" },
      });
      return;
    }

    const propertyId = notification?.propertyId ?? notification?.eventId ?? null;
    if (!propertyId) {
      return;
    }
    if (this.router.url !== "/properties") {
      this.menuService.setData({
        menu: "details",
        id: propertyId,
        propertyId,
      });
      this.router.navigate(["properties"]);
    } else {
      this.eventService.broadcast("menu-details", {
        id: propertyId,
        propertyId,
      });
    }
  }

  getLeadAssignmentTitleKey(messageKey: string): string {
    if (this.referralNotificationKeys.has(messageKey)) {
      return messageKey;
    }
    return messageKey === "t-lead-assignment"
      ? "t-lead-has-been-assigned-to-you"
      : "t-lead-assigned-to-another-agent";
  }

  updateNotificationMessageToRead(message: ChatMessage) {
    // userId serve de fallback quando o id do chat não consta da lista da
    // página de chat (ex.: conversas de outro tab/scoping).
    const chatTarget = {
      menu: "chat",
      chat: message.chat,
      userId: message.user?.id,
    };
    if (this.router.url !== "/chat") {
      this.menuService.setData(chatTarget);
      this.router.navigate(["chat"]);
    } else {
      this.eventService.broadcast("menu-chat", chatTarget);
    }
    this.setCountNotifications();
  }

  setCountNotifications() {
    this.countNotificationLeads = this.notificationsLeads?.filter(
      (e) => e.type === "LEADS" || e.type === "LEAD_ASSIGNMENT"
    ).length;

    this.countNotificationAlers = this.notificationsAlers.filter(
      (e) =>
        e.type === "CALENDAR_EVENT" ||
        e.type === "MEDIATION_AGREEMENT" ||
        e.type === "PORTAL_ALERTS" ||
        e.type === "PROPOSALS" ||
        e.type === "PROPERTIES"
    ).length;

    this.countNotificationMessages = this.notificationsMessages.length;

    this.countNotification = this.notificationsLeads.filter(
      (e) => e.read === false
    ).length;

    this.countNotification += this.notificationsAlers.filter(
      (e) => e.read === false
    ).length;

    this.countNotification += this.notificationsMessages.filter(
      (e) => e.unread === true
    ).length;

    this.notificationsAlers = this.notificationsAlers.sort((a, b) =>
      this.compareData(b, a)
    );
  }

  updateNotificationsMessagesStatus(messages: any) {
    this.chatService.usersOnline$.asObservable().subscribe((data) => {
      this.notificationsMessages.forEach((cud) => {
        const usersOnline = data.find((ud) => ud.id === cud.user?.id);
        if (usersOnline) cud.status = "online";
        else cud.status = "away";
      });
    });
  }

  getCountRead(type: string) {
    if (type === "ALERT") {
      return this.notificationsAlers.filter((e) => e.read === false).length;
    }
    if (type === "LEADS" || type === "LEAD_ASSIGNMENT") {
      return this.notificationsLeads.filter((e) => e.read === false).length;
    }
    this.notificationsMessages.filter((e) => e.unread === true).length;
    if (type === "MESSAGES") {
      return this.notificationsMessages.filter((e) => e.unread === true).length;
    }

    return 0;
  }

  compareData(a: NotifcationModel, b: NotifcationModel) {
    if (a.createdAt && b.createdAt) {
      const d1 = new Date(a.createdAt);
      const d2 = new Date(b.createdAt);
      return d1.getTime() - d2.getTime();
    }
    return 0;
  }

  dateFormate(date: any) {
    //2024-05-15T01:19:04+01:00
    const d = new Date(date);
    return this.calcularTempoDecorrido(d);
  }

  dateDiffToDays(date1: Date, date2: Date): number {
    const difMilisseg = date2.getTime() - date1.getTime();
    const difDays = difMilisseg / (24 * 60 * 60 * 1000);

    if (Math.floor(difDays) >= 0) return Math.ceil(difDays);
    else {
      return -1;
    }
  }

  dateTimeZone(date: Date) {
    const dt = new Date(date.toISOString());
    const dtNumber = dt.getTime();
    const dtOffset = dt.getTimezoneOffset() * 60000;
    const dtUTC = new Date();
    dtUTC.setTime(dtNumber - dtOffset);
    return dtUTC;
  }

  calcularTempoDecorrido(data: Date) {
    // Data e hora atuais
    let dataAtual = new Date();

    // Diferença em milissegundos entre a data atual e a data fornecida
    let diferencaEmMilissegundos = dataAtual.getTime() - data.getTime();

    // Converter a diferença de milissegundos para segundos
    let segundosDecorridos = Math.floor(diferencaEmMilissegundos / 1000);

    // Se os segundos decorridos forem menores que 60
    if (segundosDecorridos < 60) {
      return segundosDecorridos <= 1
        ? { txt: "t-second-ago", val: segundosDecorridos }
        : { txt: "t-seconds-ago", val: segundosDecorridos };
    }
    // Se os segundos decorridos forem menores que 60 * 60 (1 hora)
    else if (segundosDecorridos < 60 * 60) {
      let minutosDecorridos = Math.floor(segundosDecorridos / 60);
      return minutosDecorridos <= 1
        ? { txt: "t-minute-ago", val: minutosDecorridos }
        : { txt: "t-minutes-ago", val: minutosDecorridos };
    }
    // Se os segundos decorridos forem menores que 24 * 60 * 60 (1 dia)
    else if (segundosDecorridos < 24 * 60 * 60) {
      let horasDecorridas = Math.floor(segundosDecorridos / (60 * 60));
      return horasDecorridas <= 1
        ? { txt: "t-hour-ago", val: horasDecorridas }
        : { txt: "t-hours-ago", val: horasDecorridas };
    }
    // Se os segundos decorridos forem menores que 7 * 24 * 60 * 60 (1 semana)
    else if (segundosDecorridos < 7 * 24 * 60 * 60) {
      let diasDecorridos = Math.floor(segundosDecorridos / (24 * 60 * 60));
      return diasDecorridos <= 1
        ? { txt: "t-day-ago", val: diasDecorridos }
        : { txt: "t-days-ago", val: diasDecorridos };
    }
    // Caso contrário, calcular o número de semanas
    else {
      let semanasDecorridas = Math.floor(
        segundosDecorridos / (7 * 24 * 60 * 60)
      );
      return semanasDecorridas <= 1
        ? { txt: "t-week-ago", val: semanasDecorridas }
        : { txt: "t-weeks-ago", val: semanasDecorridas };
    }
  }

  initFlag() {
    this.cookieValue = this._cookiesService.get("lang");
    const val = this.listLang.filter((x: any) => {
      return x.lang === this.cookieValue;
    });
    this.countryName = val.map((element: any) => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) {
        this.valueset = "assets/images/flags/us.svg";
      }
    } else {
      this.flagvalue = val.map((element: any) => element.flag);
    }
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }

  /**
   * Fullscreen method
   */
  fullscreen() {
    document.body.classList.toggle("fullscreen-enable");
    if (
      !document.fullscreenElement &&
      !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement
    ) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        /* Firefox */
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        /* IE/Edge */
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }

  /**
   * Topbar Light-Dark Mode Change
   */
  private applyMode(mode: string) {
    const normalizedMode = mode === "dark" ? "dark" : "light";

    this.mode = normalizedMode;
    document.documentElement.setAttribute("data-layout-mode", normalizedMode);
    document.body.setAttribute("data-layout-mode", normalizedMode);
  }

  private applyPersistedMode() {
    const persistedMode = localStorage.getItem(this.layoutModeStorageKey);
    if (persistedMode === "light" || persistedMode === "dark") {
      this.applyMode(persistedMode);
    }
  }

  changeMode(mode: string) {
    const normalizedMode = mode === "dark" ? "dark" : "light";
    this.eventService.broadcast("changeMode", normalizedMode);
    localStorage.setItem(this.layoutModeStorageKey, normalizedMode);
    this.applyMode(normalizedMode);
  }

  /***
   * Language Value Set
   */
  setLanguage(text: string, lang: string, flag: string) {
    this.countryName = text;
    this.flagvalue = flag;
    this.cookieValue = lang;
    this._cookiesService.set("lang", lang);
    this.languageService.setLanguage(lang);
  }

  onLanguageSelect(event: Event, item: { text: string; lang: string; flag: string }) {
    event.preventDefault();
    event.stopPropagation();
    this.setLanguage(item.text, item.lang, item.flag);
  }

  /**
   * Logout the user
   */
  logout() {
    this.authService.logout().subscribe(() => {
      this.router.navigate(["/login"]);
    });
  }

  checkLoginStatus() {
    if (this.authService.currentUserValue && !localStorage.getItem("toast")) {
      this.authService.getUser().subscribe(
        (user) => {
          this.authService.saveUserToLocalStorage(user);
        },
        (error) => {
          let err = error ? error : "";
          console.log(err);
        }
      );

      /*setInterval(() => {
  
        this.authService.getUser().subscribe(user => {
          this.authService.saveUserToLocalStorage(user);
        },
          error => {
            let err = error ? error : '';
            console.log(err);
          });
  
      }, 60000);*/
      //this.authService.removeUserToLocalStorage();
    }
  }

  createDateFormat(date: any) {
    const d = new Date(date);
    return d.toLocaleString();
  }

  compareDate1WithNow(date1: any) {
    const d1 = new Date(date1);
    const dNow = new Date();
    if (
      d1.getDate() === dNow.getDate() &&
      d1.getMonth() === dNow.getMonth() &&
      d1.getFullYear() === dNow.getFullYear()
    ) {
      return false;
    }
    // return d1 > dNow;
    return dNow.getTime() - d1.getTime();
  }

  supportBack() {
    this.authService.backToSupportAccount().subscribe({
      next: (result: any) => {
        if (result?.success) {
          this.authService.removeEntityLogo();
          location.href = location.origin;
        }
      },
    });
  }

  /** "Ver como": o MASTER escolhe o utilizador da entidade a ver. */
  openImpersonation(): void {
    this.modalService.open(ImpersonationModalComponent, {
      centered: true,
      backdrop: "static",
    });
  }

  /** Sai do "Ver como" e volta à conta do MASTER. */
  stopImpersonation(): void {
    this.authService.stopImpersonation().subscribe({
      next: () => {
        this.authService.removeEntityLogo();
        location.href = location.origin;
      },
    });
  }

  initModalPortalErrors() {
    if (this.modalService.hasOpenModals()) {
      this.modalService.dismissAll();
    }
    this.modalRef = this.modalService.open(this.contenttop, {
      size: "fullscreen",
      centered: true,
      scrollable: true,
      backdrop: "static",
      keyboard: false,
      windowClass: "modal-portal-errors-properties",
    });

    this.modalRef.dismissed.subscribe(() => {
      this.portalListErrors = false;
      this.portalExportError.status = false;
      this.isPortalAlert = false;
    });

    this.modalRef.closed.subscribe(() => {
      this.portalListErrors = false;
      this.portalExportError.status = false;
      this.isPortalAlert = false;
    });
  }

  activeIdChangeNabTab() {
    this.currentNavTabSubject.next(this.nabTabActive);

    if (this.currentNavTabSubject.getValue() === 1)
      this.portalExportError.isExported = true;
    else if (this.currentNavTabSubject.getValue() === 2)
      this.portalExportError.isExported = false;
  }

  exchangeModal() {
    if (!this.exchanges) {
      this.exchangeService.getExchangeRates().subscribe((data) => {
        this.exchanges = data;
        this.modalService.open(this.contentExchange, {
          size: "md",
          centered: true,
        });
      });
    } else {
      this.modalService.open(this.contentExchange, {
        size: "md",
        centered: true,
      });
    }
  }

  loadJS() {
    const scriptLoadBs: any = document.querySelector("#bs-js");
    if (!scriptLoadBs) {
      const node = document.createElement("script");
      node.src = "assets/libs/bootstrap/js/bootstrap.bundle.min.js";
      node.type = "text/javascript";
      node.async = true;
      node.id = "bs-js";
      document.body.appendChild(node);
    }
  }

  onChangeCountry(event: any) {
    if (event) {
      this.topBarService.countrySelected = { ...event, agencies: [] };
      this.agencies = event.agencies;
    } else {
      this.topBarService.countrySelected = undefined;
      this.agencies = [];
      this.topBarService.removeUserDataPrefToLocalStorage(
        this.currentUser.id,
        this.currentUser.entity
      );
    }
    console.log(event);
  }

  onChangeAgency(event: any) {
    if (this.topBarService.countrySelected?.agencies) {
      this.topBarService.countrySelected.agencies = event;
    }
    // console.log(this.topBarService.countrySelected);
    if (this.topBarService.countrySelected)
      this.topBarService.saveUserDataPrefToLocalStorage(
        this.topBarService.countrySelected
      );
  }

  onClearCountry() {
    this.topBarService.countrySelected = undefined;
    this.agencies = [];
    this.selectedAgenciesId = [];
    this.topBarService.removeUserDataPrefToLocalStorage(
      this.currentUser.id,
      this.currentUser.entity
    );
  }

  onResetCountry() {
    this.selectedCountryId = null;
    this.onClearCountry();
  }

  closeDropdown() {
    const toggleButton = document.getElementById("dropdownCountryRef");
    toggleButton?.click();
  }

  openPropertyContactsNotifications(content: any, data: any) {
    this.selectedContacts = data;
    this.modalService.open(content, {
      size: "lg",
      centered: true,
      scrollable: true,
      backdrop: "static",
      keyboard: false,
    });
  }

  getDash(quality: number) {
    const circumference = 2 * Math.PI * 15.91549430918954;
    const offset = circumference - (quality / 100) * circumference;
    return `${circumference - offset} ${circumference}`;
  }

  generateMlsLink(title: string, uniqueId: string, link: string) {
    const link1 = link.startsWith("http") ? link : "https://" + link;
    return `${link1}/property/${this.getTitleFormat(title)}/${uniqueId}`;
  }

  getTitleFormat(title: string) {
    return title
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "") // Remove acentos
      .replace(/([^\w]+|\s+)/g, "-") // Substitui espaço e outros caracteres por hífen
      .replace(/\-\-+/g, "-") // Substitui multiplos hífens por um único hífen
      .replace(/(^-+|-+$)/, "")
      .toLowerCase();
  }

  priceFormat(propertyPrice: any, symbol: any = "€") {
    if (propertyPrice) {
      let price = propertyPrice.toString().split(".");
      const spaces = (price: any) =>
        String(price).replace(/(?!^)(?=(?:\d{3})+$)/g, " ");
      const price1 = spaces(price[0]);
      if (price.length > 1) return price1 + "," + price[1] + " " + symbol;

      return price1 + " " + symbol;
    }
    return propertyPrice;
  }

  seeDetailsContact(contact: any, property: any, content: any) {
    this.contactSelected = {
      ...property,
      ...contact,
      propertyId: property.id,
      contactId: contact.id,
      attrQuality: this.getAttributes(contact.attrQuality, contact?.default100),
    };
    this.modalService.open(content, { size: "xl", centered: true });
  }

  getAttributes(attrQuality: any, defaultValues: any = {}): any[] {
    return Object.entries(attrQuality)
      .map(([key, value]) => {
        if (key && (value || value === 0)) {
          const isDefault =
            defaultValues[key] !== undefined && defaultValues[key] === true;
          return {
            name: "t-new-contacts.t-" + key,
            value: value,
            isDefault: isDefault,
            key: key,
          };
        } else {
          return {};
        }
      })
      .filter((attr) => !attr.isDefault);
  }

  addContactToProperty(data: any) {
    if (data && data.propertyId && data.contactId) {
      this.contactsService
        .addContactToProperty(data.propertyId, data.contactId)
        .subscribe({
          next: (result: any) => {
            if (result) {
              data.addedToProperty = true;
              Swal.fire({
                title: this.translate.instant("t-add-success"),
                icon: "success",
              });
            }
          },
          error: (err: any) => {
            console.error(err);
          },
        });
    }
  }

  removeContactFromProperty(data: any) {
    if (data && data.propertyId && data.contactId) {
      this.contactsService
        .removeContactFromProperty(data.propertyId, data.contactId)
        .subscribe({
          next: (result: any) => {
            if (result) {
              data.addedToProperty = false;
              Swal.fire({
                title: this.translate.instant("t-remove-success"),
                icon: "success",
              });
            }
          },
          error: (err: any) => {
            console.error(err);
          },
        });
    }
  }

  createDeal(data: any) {
    if (data && data.propertyId && data.contactId) {
      const values = {
        propertyId: data.propertyId,
        contact: data.contactId,
      };
      this.dealsService.createManualDeal(values, "sale").subscribe({
        next: (result: any) => {
          if (result) {
            data.dealCreated = true;
            Swal.fire({
              title: this.translate.instant("t-create-success"),
              icon: "success",
            });
          }
        },
        error: (err: any) => {
          console.error(err);
        },
      });
    }
  }

  getTooltipText(key: string, preferences: any) {
    if (preferences && preferences[key]) {
      const contactValue = preferences[key]?.contactValue;
      let value = "";
      if (contactValue?.min || contactValue?.max) {
        if (contactValue?.min && contactValue?.max) {
          value = `<br>Min: ${this.priceFormat(
            contactValue.min
          )}, Max: ${this.priceFormat(contactValue.max)}`;
        } else if (contactValue?.min) {
          value = `Min: ${this.priceFormat(contactValue.min)}`;
        } else if (contactValue?.max) {
          value = `Max: ${this.priceFormat(contactValue.max)}`;
        }
      } else if (contactValue?.district) {
        value = `${contactValue.district}`;
        if (contactValue?.county) {
          value += `, ${contactValue.county}`;
          if (contactValue?.parish) {
            value += `, ${contactValue.parish}`;
          }
        }
      } else {
        value = contactValue;
      }
      let propertyValue = "";
      if (preferences[key]?.propertyValue?.district) {
        propertyValue = `${preferences[key]?.propertyValue.district}`;
        if (preferences[key]?.propertyValue?.county) {
          propertyValue += `, ${preferences[key]?.propertyValue.county}`;
          if (preferences[key]?.propertyValue?.parish) {
            propertyValue += `, ${preferences[key]?.propertyValue.parish}`;
          }
        }
      } else if (key === "budget") {
        propertyValue = preferences[key]?.propertyValue
          ? this.priceFormat(preferences[key]?.propertyValue)
          : "N/A";
      } else {
        propertyValue = preferences[key]?.propertyValue || "N/A";
      }
      const html = `${this.translate.instant(
        "t-contact"
      )}: ${value} <br> <br> ${this.translate.instant(
        "t-property"
      )}: ${propertyValue}`;
      return html;
    } else {
      return null;
    }
  }

  parseMessage(n: any): { key: string; params?: Record<string, any> } {
    try {
      const parsed =
        typeof n.message === "string" ? JSON.parse(n.message) : n.message;

      if (parsed && typeof parsed === "object" && parsed.key) {
        return parsed;
      }
      return { key: n.message || "", params: {} };
    } catch {
      return { key: n.message || "", params: {} };
    }
  }

  getMessageKey(n: any): string {
    const parsed = this.parseMessage(n);
    return parsed?.key || "";
  }

  ngOnDestroy(): void {
    this.chatSubscriptions.unsubscribe();
    if (this.portalErrorsSubscription)
      this.portalErrorsSubscription?.unsubscribe();
    if (this.portalExportSubscription)
      this.portalExportSubscription?.unsubscribe();
    this.aiBalanceSub?.unsubscribe();
    this.aiHasWalletSub?.unsubscribe();
    this.aiPulseSub?.unsubscribe();
    clearTimeout(this.aiBurstTimeout);
  }
}
